/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent
     */
    contents?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'contents': !exists(json, 'contents') ? undefined : json['contents'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'contents': value.contents,
    };
}

